import Vue from "vue";
Vue.component("notification-type-cascading-selector", {
    props: [
        "values",
        "language",
        "disabled",
        "domain",
        "placeholder",
        "hasTooltip",
        "mainTooltip",
        "modificationTooltip",
        "proposedModificationTypeTooltip",
        "objectionTooltip",
        "arbitrationProcedureTooltip"
    ],
    data() {
        return {
            loading: false,
            myValues: [],
            loadingText: window.labels.loading,
            isDisabled: this.disabled,
            parameterNotificationMainTypes: [
                { id: 49, text: window.labels.statistics },
                { id: 48, text: window.labels.thresholds },
                { id: 50, text: window.labels.domesticLegislations },
                { id: 39, text: window.labels.modificationsToCoverage },
                { id: 47, text: window.labels.modificationsToPublicationMedia }
            ],
            parameterNotificationModificationTypes: [],
            parameterNotificationProposedModificationTypes: [],
            parameterNotificationObjectionModificationTypes: [],
            parameterNotificationArbitrationProcedureTypes: [],
            notificationMainTypes: [
                { id: 49, text: window.labels.statistics },
                { id: 48, text: window.labels.thresholds },
                { id: 50, text: window.labels.domesticLegislations },
                { id: 39, text: window.labels.modificationsToCoverage },
                { id: 47, text: window.labels.modificationsToPublicationMedia }
            ],
            filteredNotificationMainTypes: [],
            modificationTypes: [
                { id: 39, text: window.labels.proposedModification },
                { id: 40, text: window.labels.objections },
                { id: 41, text: window.labels.writtenExchanges },
                { id: 52, text: window.labels.arbitrationProcedures },
                { id: 51, text: window.labels.additionalInfo },
                { id: 46, text: window.labels.letDocuments },
            ],
            filteredNotificationModificationTypes: [],
            proposedModificationTypes: [
                { id: 39, text: window.labels.newProposedModifications },
                { id: 44, text: window.labels.withdrawalOfProposedModifications },
                { id: 45, text: window.labels.implementationOfProposedModifications }
            ],
            filteredNotificationProposedModificationTypes: [],
            objectionModificationTypes: [
                { id: 40, text: window.labels.newObjections },
                { id: 43, text: window.labels.withdrawalOfObjections },
            ],
            filteredNotificationObjectionModificationTypes: [],
            arbitrationProcedureTypes: [
                { id: 52, text: window.labels.invocationOfArbitrationProcedures },
                { id: 53, text: window.labels.withdrawalOfReferralToArbitrationProcedures },
            ],
            filteredNotificationArbitrationProcedureTypes: [],
            showModificationType: false,
            showProposedModificationType: false,
            showObjectionModificationType: false,
            showArbitrationProcedureType: false,
        }
    },
    methods: {
        getFilteredNotificationMainTypes(text) {
            const self = this;

            self.filteredNotificationMainTypes = self.notificationMainTypes.filter((member) => {
                return member.text
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        },
        getFilteredNotificationModificationTypes(text) {
            const self = this;

            self.filteredNotificationModificationTypes = self.modificationTypes.filter((member) => {
                return member.text
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        },
        getFilteredNotificationProposedModificationTypes(text) {
            const self = this;

            self.filteredNotificationProposedModificationTypes = self.proposedModificationTypes.filter((member) => {
                return member.text
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        },
        getFilteredNotificationObjectionModificationTypes(text) {
            const self = this;

            self.filteredNotificationObjectionModificationTypes = self.objectionModificationTypes.filter((member) => {
                return member.text
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        },
        getFilteredNotificationArbitrationProcedureTypes(text) {
            const self = this;

            self.filteredNotificationArbitrationProcedureTypes = self.arbitrationProcedureTypes.filter((member) => {
                return member.text
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        },
        plotValues() {
            const self = this;

            let tempValues = [];

            if (self.parameterNotificationMainTypes.length > 0) {
                self.parameterNotificationMainTypes.forEach(value => {
                    tempValues.push(value);
                });
            }

            if (self.parameterNotificationModificationTypes.length > 0) {
                self.parameterNotificationModificationTypes.forEach(value => {
                    tempValues.push(value);
                });
            }

            if (self.parameterNotificationProposedModificationTypes.length > 0) {
                self.parameterNotificationProposedModificationTypes.forEach(value => {
                    tempValues.push(value);
                });
            }

            if (self.parameterNotificationObjectionModificationTypes.length > 0) {
                self.parameterNotificationObjectionModificationTypes.forEach(value => {
                    tempValues.push(value);
                });
            }

            if (self.parameterNotificationObjectionModificationTypes.length > 0) {
                self.parameterNotificationObjectionModificationTypes.forEach(value => {
                    tempValues.push(value);
                });
            }

            console.log(tempValues);
            self.myValues = tempValues;
        }
    },
    watch: {
        values: function (values) {
            if (values != null && values.length > 0) {

            }
            else {
                self.parameterNotificationMainTypes = [
                    { id: 49, text: window.labels.statistics },
                    { id: 48, text: window.labels.thresholds },
                    { id: 50, text: window.labels.domesticLegislations },
                    { id: 39, text: window.labels.modificationsToCoverage },
                    { id: 47, text: window.labels.modificationsToPublicationMedia }
                ];
                self.parameterNotificationModificationTypes = [];
                self.parameterNotificationProposedModificationTypes = [];
                self.parameterNotificationObjectionModificationTypes = [];
                self.parameterNotificationArbitrationProcedureTypes = [];
            }
        },
        myValues: function (values) {
            const self = this;

            let tempValues = [];

            if (values != null && values.length > 0) {                
                values.forEach(member => {
                    tempValues.push(member);
                });                
            }      

            self.$emit("update:values", tempValues);
        },
        parameterNotificationMainTypes: function (values) {

            const self = this;

            let hasModificationType = false;
            self.showModificationType = false;

            if (values != null && values.length > 0) {
                values.forEach(value => {
                    if (!hasModificationType && value.id == 39) {
                        hasModificationType = true;
                        self.showModificationType = true;
                    }
                });
            }
            else {
                self.parameterNotificationModificationTypes = [];
            }

            self.plotValues();
        },
        parameterNotificationModificationTypes: function (values) {

            const self = this;

            let hasProposedModificationType = false;
            let hasObjectionModificationType = false;
            let hasArbitrationProcedureType = false;

            self.showProposedModificationType = false;
            self.showObjectionModificationType = false;
            self.showArbitrationProcedureType = false;


            if (values != null && values.length > 0) {
                values.forEach(value => {
                    if (!hasProposedModificationType && value.id == 39) {
                        hasProposedModificationType = true;
                        self.showProposedModificationType = true;
                    }

                    if (!hasObjectionModificationType && value.id == 40) {
                        hasObjectionModificationType = true;
                        self.showObjectionModificationType = true;
                    }

                    if (!hasArbitrationProcedureType && value.id == 52) {
                        hasArbitrationProcedureType = true;
                        self.showArbitrationProcedureType = true;
                    }
                });
            }
            else {
                self.parameterNotificationProposedModificationTypes = [];
                self.parameterNotificationObjectionModificationTypes = [];
                self.parameterNotificationArbitrationProcedureTypes = [];
            }

            self.plotValues();
        },
        parameterNotificationProposedModificationTypes: function (values) {

            const self = this;

            self.plotValues();
        },
        parameterNotificationObjectionModificationTypes: function (values) {

            const self = this;

            self.plotValues();
        },
        parameterNotificationArbitrationProcedureTypes: function (values) {

            const self = this;

            self.plotValues();            
        }
    },
    mounted() {
        const self = this;

        self.filteredNotificationMainTypes = self.notificationMainTypes;
        self.filteredNotificationModificationTypes = self.modificationTypes;
        self.filteredNotificationProposedModificationTypes = self.proposedModificationTypes;
        self.filteredNotificationObjectionModificationTypes = self.objectionModificationTypes;
        self.filteredNotificationArbitrationProcedureTypes = self.arbitrationProcedureTypes;
    },
    computed: {
        notificationTypeLabel: function () {
            return window.labels.notificationType;
        },
        typeOfDocumentsRelatedToModificationsLabel: function () {
            return window.labels.typeOfDocumentsRelatedToModifications;
        },
        additionalFilterProposedModificationsLabel: function () {
            return window.labels.additionalFilterProposedModifications;
        },
        additionalFilterObjectionsLabel: function () {
            return window.labels.additionalFilterObjections;
        },
        additionalFilterArbitrationProceduresLabel: function () {
            return window.labels.additionalFilterArbitrationProcedures;
        },
        selectATypeLabel: function () {
            return window.labels.selectAType;
        },
        selectAModificationTypeLabel: function () {
            return window.labels.SelectAModificationType;
        },
        selectAProposedModificationTypeLabel: function () {
            return window.labels.selectAProposedModificationType;
        },
        selectAProposedModificationTypeLabel: function () {
            return window.labels.selectAProposedModificationType;
        },
        selectAnObjectionTypeLabel: function () {
            return window.labels.selectAnObjectionType;
        },
        selectAnArbitrationProcedureTypeLabel: function () {
            return window.labels.selectAnArbitrationProcedureType;
        }
    },
    template: `
        <div>
		    <div class="columns">
                <div class="column is-12">
                    <b-field>
                        <template #label>
                            <span>{{notificationTypeLabel}}</span>
                            <b-tooltip v-if="hasTooltip" class="custom" type="is-success" :label="mainTooltip" position="is-top" multilined>
                                <b-icon size="is-small" icon="question-circle"></b-icon>
                            </b-tooltip>
                        </template>
                        <b-taginput ref="notificationMainTypeMultiselect"
                                    autocomplete
                                    :placeholder="selectATypeLabel"
                                    v-model="parameterNotificationMainTypes"
                                    :data="filteredNotificationMainTypes"
                                    field="text"
                                    :open-on-focus="true"
                                    @@typing="getFilteredNotificationMainTypes">
                        </b-taginput>
                    </b-field>
                </div>
            </div>
            <div class="columns mt-2" v-if="showModificationType">
                <div class="column is-12">
                    <b-field>
                        <template #label>
                            <span>{{typeOfDocumentsRelatedToModificationsLabel}}</span>
                            <b-tooltip v-if="hasTooltip" class="custom" type="is-success" :label="modificationTooltip" position="is-top" multilined>
                                <b-icon size="is-small" icon="question-circle"></b-icon>
                            </b-tooltip>
                        </template>
                        <b-taginput ref="notificationModificationTypeMultiselect"
                                    autocomplete
                                    :placeholder="selectAModificationTypeLabel"
                                    v-model="parameterNotificationModificationTypes"
                                    :data="filteredNotificationModificationTypes"
                                    field="text"
                                    :open-on-focus="true"
                                    @@typing="getFilteredNotificationModificationTypes">
                        </b-taginput>
                    </b-field>
                </div>
            </div>
            <div class="columns mt-2" v-if="showProposedModificationType">
                <div class="column is-12">
                    <b-field>
                        <template #label>
                            <span>{{additionalFilterProposedModificationsLabel}}</span>
                            <b-tooltip v-if="hasTooltip" class="custom" type="is-success" :label="proposedModificationTypeTooltip" position="is-top" multilined>
                                <b-icon size="is-small" icon="question-circle"></b-icon>
                            </b-tooltip>
                        </template>
                        <b-taginput ref="notificationProposedModificationTypeMultiselect"
                                    autocomplete
                                    :placeholder="selectAProposedModificationTypeLabel"
                                    v-model="parameterNotificationProposedModificationTypes"
                                    :data="filteredNotificationProposedModificationTypes"
                                    field="text"
                                    :open-on-focus="true"
                                    @@typing="getFilteredNotificationProposedModificationTypes">
                        </b-taginput>
                    </b-field>
                </div>
            </div>
            <div class="columns mt-2" v-if="showObjectionModificationType">
                <div class="column is-12">
                    <b-field>
                        <template #label>
                            <span>{{additionalFilterObjectionsLabel}}</span>
                            <b-tooltip v-if="hasTooltip" class="custom" type="is-success" :label="objectionTooltip" position="is-top" multilined>
                                <b-icon size="is-small" icon="question-circle"></b-icon>
                            </b-tooltip>
                        </template>
                        <b-taginput ref="notificationObjectionModificationTypeMultiselect"
                                    autocomplete
                                    :placeholder="selectAnObjectionTypeLabel"
                                    v-model="parameterNotificationObjectionModificationTypes"
                                    :data="filteredNotificationObjectionModificationTypes"
                                    field="text"
                                    :open-on-focus="true"
                                    @@typing="getFilteredNotificationObjectionModificationTypes">
                        </b-taginput>
                    </b-field>
                </div>
            </div>
            <div class="columns mt-2" v-if="showArbitrationProcedureType">
                <div class="column is-12">
                    <b-field>
                        <template #label>
                            <span>{{additionalFilterArbitrationProceduresLabel}}</span>
                            <b-tooltip v-if="hasTooltip" class="custom" type="is-success" :label="arbitrationProcedureTooltip" position="is-top" multilined>
                                <b-icon size="is-small" icon="question-circle"></b-icon>
                            </b-tooltip>
                        </template>
                        <b-taginput ref="notificationArbitrationProcedureTypeMultiselect"
                                    autocomplete
                                    :placeholder="selectAnArbitrationProcedureTypeLabel"
                                    v-model="parameterNotificationArbitrationProcedureTypes"
                                    :data="filteredNotificationArbitrationProcedureTypes"
                                    field="text"
                                    :open-on-focus="true"
                                    @@typing="getFilteredNotificationArbitrationProcedureTypes">
                        </b-taginput>
                    </b-field>
                </div>
            </div>
        </div>
	`
});